import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InternationalActivitiesUsermanualsComponent } from './international-activities-usermanuals.component';
import { InternationalActivitiesUsermanualsRoutingModule } from "./InternationalActivities-usermanuals-routing";
import { InternationalActivitiesUserManualsFilterClass } from './InternationalActivities-usermanuals.pipe';

import { TranslateModule } from "@ngx-translate/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from '@angular/forms';
@NgModule({
    imports: [
      CommonModule,
    InternationalActivitiesUsermanualsRoutingModule,
      NgbModule,
    TranslateModule, FormsModule
    ],
  declarations: [InternationalActivitiesUsermanualsComponent, InternationalActivitiesUserManualsFilterClass]
  })
export class InternationalActivitiesUsermanualsModule { }
